import { forwardRef } from "react";
import { useExperience } from "@/context/ExperienceContext";

export const VideoStage = forwardRef(function VideoStage({ videoRef, mobile }, stageRef) {
  const { scene } = useExperience();
  return (
    <div ref={stageRef} className="rrb-stage" data-testid="video-stage">
      <div className="rrb-stage-inner">
        <video
          key={mobile ? "m" : "d"}
          ref={videoRef}
          data-testid="commercial-video"
          className="rrb-video"
          poster="/media/poster.jpg"
          muted
          playsInline
          preload="auto"
          style={{ objectPosition: mobile ? `${scene.objX}% 50%` : "50% 50%" }}
        >
          <source src={mobile ? "/media/rrb-mobile.mp4" : "/media/rrb-scrub.mp4"} type="video/mp4" />
          <source src="/media/rrb-scrub.webm" type="video/webm" />
        </video>
        <div className="rrb-wash" aria-hidden />
        <div className="rrb-dim" aria-hidden />
        <div className="rrb-scrim" aria-hidden />
      </div>
    </div>
  );
});
